module.exports = __webpack_public_path__ + "static/media/sw-mobile.d8bf9edb.jpg";